// extracted by mini-css-extract-plugin
module.exports = {"container":"RegisterSuccessPage_container__1Gd8e"};